exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-item[data-v-67360102]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.page-item.disabled[data-v-67360102]{cursor:not-allowed;opacity:.65}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67360102","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/basicos/Pagination.vue
// module id = 80+0
// module chunks = 49